import { useState, useEffect } from "react";
import ModalCustom from "./modal-template-default";
import DatePicker from "../DatePicker";
import Required from "../Required";
import Button from "../Button";
import { validateForm, validateStyle } from "../../components/ValidateForm";
import { toast } from "react-toastify";
import api from "../../services/api";
import useWrapper from "../../hooks/useWrapper";
export default function ModalSlipDateChange(props) {
  const { show, onHide, slip, refreshCallback } = props;
  const { config } = useWrapper();

  const [datePayment, setdatePayment] = useState(slip?.due_date);
  const [isWaitingResponse, setisWaitingResponse] = useState();

  useEffect(() => {
    if (show && !!slip?.due_date) {
      setdatePayment(slip?.due_date);
    }
  }, [!!slip?.due_date, show]);

  const closeModal = () => {
    onHide();
    setdatePayment();
  };

  const changeDate = async () => {
    const _is_valid = validateForm(document.getElementById("date_change_container"));
    if (!_is_valid) return;
    setisWaitingResponse(true);
    try {
      const { data: _slip } = await api.put(
        `paymentslips/${slip.id}`,
        {
          due_date: datePayment,
        },
        config,
      );
      refreshCallback();
      toast.success("Data do Vencimento Modificado!");
    } catch (__err) {
      toast.error("Problemas ao tentar modificar o vencimento do pagamento!");
      console.log("__err", __err);
    } finally {
      closeModal();
      setisWaitingResponse(false);
    }
  };

  return (
    <ModalCustom show={show} onHide={closeModal} id="date_change_container" disableClose={!!isWaitingResponse}>
      <ModalCustom.Header>
        <ModalCustom.Title>Mudar Vencimento</ModalCustom.Title>
      </ModalCustom.Header>
      <ModalCustom.Body>
        <p className="small-label">
          Você está prestes a modificar a data de um pagamento. Certifique-se de que a data está correta. Os valores de
          multas e juros serão calculados a partir da nova data.
        </p>
        {/* <div className="mt-2">
          <label>Data do Pagamento Atual</label>
          <DatePicker disabled={true} selected={datePayment} onChange={() => {}} />
        </div> */}
        <div className="mt-2">
          <label>
            Nova Data do Pagamento <Required />
          </label>
          <DatePicker
            required={true}
            disabled={isWaitingResponse}
            selected={datePayment}
            onChange={__ev => {
              setdatePayment(__ev);
            }}
            // minDate={new Date()}
          />
        </div>
      </ModalCustom.Body>
      <ModalCustom.Footer>
        <Button disabled={isWaitingResponse} color="primary_ghost" onClick={closeModal}>
          Cancelar
        </Button>
        <Button disabled={isWaitingResponse} onClick={changeDate} loading={isWaitingResponse}>
          Mudar de Vencimento
        </Button>
      </ModalCustom.Footer>
    </ModalCustom>
  );
}
